import * as Yup from "yup";
import React from "react";

import {TranslatedText} from "../../../helpers/helpers";

import { validEmail} from "../../forms/CustomSignUp/validations";
import {
  CaseForms,
  CaseMutationType,
  CaseStepperType,UserRoleEnum,
} from "../../../helpers/enums";
import {SPID_REGISTRATION} from "../../../helpers/mutations";

// Il model definisce la struttura dei dati
// formId è un identificatore del form
// formField contiene la definizione dei singoli campi
const model = {
    formId: CaseForms.SpidRegister,
  formField: {
    typeUser: {
      name: 'typeUser',
      label: '',
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.required" />,
      type: 'radio',
      summaryView: false,
      options: [
        {
          label: <TranslatedText i18nKey="registration.typePrivate" />,
          value: UserRoleEnum.PRIVATE,
          grid: { md: 3 }
        },
        {
          label: <TranslatedText i18nKey="registration.typeUserBusiness" />,
          value: UserRoleEnum.COMPANY,
          grid: { md: 4}
        },
        {
          label: <TranslatedText i18nKey="registration.typeAdminBuilding" />,
          value: UserRoleEnum.CONDOMINIUM_ADMIN,
          grid: { md: 4 }
        }
      ],


    },
    //PRIVATE
    name: {
      name: "name",
      label: <span><TranslatedText i18nKey="registration.name.value" /> *</span>,
      placeholder: (
        <TranslatedText i18nKey="registration.name.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      readonly: true,
    },
    surname: {
      name: "surname",
      label:<span> <TranslatedText i18nKey="registration.surname.value" /> *</span>,
      placeholder: (
        <TranslatedText i18nKey="registration.surname.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      readonly: true,
    },
    email: {
      name: "email",
      label: <span><TranslatedText i18nKey="registration.emailAddress.value" />*</span>,
      placeholder: (
        <TranslatedText i18nKey="registration.emailAddress.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      readonly: true,
    },

    codiceFiscale: {
      name: "codiceFiscale",
      label: <span><TranslatedText i18nKey="registration.fiscalCode.value" />*</span>,
      placeholder: (
        <TranslatedText i18nKey="registration.fiscalCode.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      readonly: true,
    },
    fisso: {
      name: "fisso",
      label: <TranslatedText i18nKey="registration.phone1.value" />,
      placeholder: (
        <TranslatedText i18nKey="registration.phone1.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    cellulare: {
      name: "cellulare",
      label: <span><TranslatedText i18nKey="registration.phone2.value" />*</span>,
      placeholder: (
        <TranslatedText i18nKey="registration.phone2.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },

    //COMPANY
    businessName: {
      name: "businessName",
      label: <span><TranslatedText i18nKey="business.name.label" />*</span>,
      placeholder: (
        <TranslatedText i18nKey="registration.name.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      readonly: true,
    },
    businessSurname: {
      name: "businessSurname",
      label: <span><TranslatedText i18nKey="business.surname.label" />*</span>,
      placeholder: (
        <TranslatedText i18nKey="registration.surname.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      readonly: true,
    },
    fiscalCode: {
      name: "fiscalCode",
      label: <span><TranslatedText i18nKey="business.codFiscale.label" />*</span>,
      placeholder: (
        <TranslatedText i18nKey="registration.fiscalCode-Iva.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      readonly: true,
    },
    pec: {
      name: "pec",
      label: <span><TranslatedText i18nKey="business.pec.label" /></span>,
      placeholder: (
        <TranslatedText i18nKey="registration.emailAddressPec.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.required" />,
      invalidErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.pec.invalid" />,
      type: "input",
    },
    emailAziendale: {
      name: "emailAziendale",
      label: <span><TranslatedText i18nKey="business.email.label" />*</span>,
      placeholder: (
        <TranslatedText i18nKey="registration.email.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      invalidErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.email.invalid" />,
      type: "input",
      readonly: true,

    },

    coFisso:{
      name: "coFisso",
      label: <TranslatedText i18nKey="registration.phone1.value" />,
      placeholder: (
        <TranslatedText i18nKey="registration.phone1.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    coCellulare: {
      name: "coCellulare",
      label: <span><TranslatedText i18nKey="registration.phone2.value" />*</span>,
      placeholder: (
        <TranslatedText i18nKey="registration.phone2.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },


    //CONDINIUM

    ragioneSociale: {
      name: "ragioneSociale",
      label: <span><TranslatedText i18nKey="registration.businessName.value" />*</span>,
      placeholder: (
        <TranslatedText i18nKey="registration.businessName.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      readonly: true,
    },
    piva: {
      name: "piva",
      label: <span><TranslatedText i18nKey="registration.fiscalCode-Iva.value" />*</span>,
      placeholder: (
        <TranslatedText i18nKey="registration.fiscalCode-Iva.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      readonly: true,
    },
    via: {
      name: "via",
      label: <span><TranslatedText i18nKey="registration.address.value" />*</span>,
      placeholder: (
        <TranslatedText i18nKey="registration.address.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: 'google-address',
      suggestionType: 'address',
      onSelect: (components, setFieldValue) => {
        setFieldValue(comune.name, components.comune);
        setFieldValue(provincia.name, components.provincia);
        setFieldValue(cap.name, components.cap);
        setFieldValue(numeroCivico.name, components.civico);
      },
    },
    numeroCivico: {
      name: "numeroCivico",
      label: <span><TranslatedText i18nKey="registration.civilNumber.value" />*</span>,
      placeholder: (
        <TranslatedText i18nKey="registration.civilNumber.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    cap:{
      name: "cap",
      label: <span><TranslatedText i18nKey="registration.CAP.value" />*</span>,
      placeholder: (
        <TranslatedText i18nKey="registration.CAP.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    comune:{
      name: "comune",
      label: <span><TranslatedText i18nKey="registration.municipality.value" />*</span>,
      placeholder: (
        <TranslatedText i18nKey="registration.municipality.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    provincia:{
      name: "provincia",
      label: <span><TranslatedText i18nKey="registration.province.value" /></span>,
      placeholder: (
        <TranslatedText i18nKey="registration.province.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    caNome: {
      name: "name",
      label: <span><TranslatedText i18nKey="registration.name.value" />*</span>,
      placeholder: (
        <TranslatedText i18nKey="registration.name.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    caCognome: {
      name: "surname",
      label: <span><TranslatedText i18nKey="registration.surname.value" />*</span>,
      placeholder: (
        <TranslatedText i18nKey="registration.surname.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    caPec: {
      name: "caPec",
      label: <span><TranslatedText i18nKey="registration.emailAddressPec.value" /></span>,
      placeholder: (
        <TranslatedText i18nKey="registration.emailAddressPec.placeholder" />
      ),
      invalidErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.pec.invalid" />,
      type: "input",
    },
    caEmail: {
      name: "email",
      label: <span><TranslatedText i18nKey="registration.emailAddress.value" />*</span>,
      placeholder: (
        <TranslatedText i18nKey="registration.emailAddress.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      invalidErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.email.invalid" />,
      type: "input",
      readonly: true,
    },
    caFisso:{
      name: "caFisso",
      label: <TranslatedText i18nKey="registration.phone1.value" />,
      placeholder: (
        <TranslatedText i18nKey="registration.phone1.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    caCellulare: {
      name: "caCellulare",
      label: <span><TranslatedText i18nKey="registration.phone2.value" />*</span>,
      placeholder: (
        <TranslatedText i18nKey="registration.phone2.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    fax: {
      name: "fax",
      label: <TranslatedText i18nKey="registration.fax.value" />,
      placeholder: (
        <TranslatedText i18nKey="registration.fax.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },

    operativaVia: {
      name: "operativaVia",
      label: <span><TranslatedText i18nKey="registration.address.value" />*</span>,
      placeholder: (
        <TranslatedText i18nKey="registration.address.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: 'google-address',
      suggestionType: 'address',
      onSelect: (components, setFieldValue) => {
        setFieldValue(operativaComune.name, components.comune);
        setFieldValue(operativaProvincia.name, components.provincia);
        setFieldValue(operativaCap.name, components.cap);
        setFieldValue(operativaNumeroCivico.name, components.civico);
      },
    },
    operativaNumeroCivico: {
      name: "operativaNumeroCivico",
      label:<span> <TranslatedText i18nKey="registration.civilNumber.value" />*</span>,
      placeholder: (
        <TranslatedText i18nKey="registration.civilNumber.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    operativaCap:{
      name: "operativaCap",
      label: <span><TranslatedText i18nKey="registration.CAP.value" />*</span>,
      placeholder: (
        <TranslatedText i18nKey="registration.CAP.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    operativaComune:{
      name: "operativaComune",
      label: <span><TranslatedText i18nKey="registration.municipality.value" />*</span>,
      placeholder: (
        <TranslatedText i18nKey="registration.municipality.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    operativaProvincia:{
      name: "operativaProvincia",
      label: <span><TranslatedText i18nKey="registration.province.value" />*</span>,
      placeholder: (
        <TranslatedText i18nKey="registration.province.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    consentMarketing: {
      name: 'consentMarketing',
      label: <TranslatedText i18nKey="registration.policy.point1"/>,
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.required"/>,
      type: 'checkbox',
    },
    consentProfiling: {
      name: 'consentProfiling',
      label: <TranslatedText i18nKey="registration.policy.point2"/>,
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.required"/>,
      type: 'checkbox',
    },


  },
};

const {
  formField: {
    typeUser,
    name,
    surname,
    email,
    codiceFiscale,
    fisso,
    cellulare,
    businessName,
    businessSurname,
    fiscalCode,
    pec,
    emailAziendale,
    ragioneSociale,
    piva,
    via,
    numeroCivico,
    cap,
    comune,
    provincia,
    caNome,
    caCognome,
    caEmail,
    caPec,
    coCellulare,
    coFisso,
    caCellulare,
    caFisso,
    fax,
    operativaVia,
    operativaComune,
    operativaCap,
    operativaNumeroCivico,
    operativaProvincia,
    consentMarketing,
    consentProfiling,

  },
} = model;

// initialValues contiene i valori iniziali del form, ne imposta anche i campi.
// Si può usare per popolare il form eventualmente.
const initialValues = {
  [typeUser.name]: UserRoleEnum.PRIVATE,
  [name.name]: "",
  [surname.name]: "",
  [codiceFiscale.name]: "",
  [email.name]: "",
  [fisso.name]: "",
  [cellulare.name]: "",
  [businessName.name]: "",
  [businessSurname.name]: "",
  [fiscalCode.name]: "",
  [pec.name]: "",
  [emailAziendale.name]: "",
  //Condominium
  [ragioneSociale.name]: "",
  [piva.name]: "",
  [via.name]: "",
  [numeroCivico.name]: "",
  [cap.name]: "",
  [comune.name]: "",
  [provincia.name]: "",
  [caNome.name]: "",
  [caCognome.name]: "",
  [caEmail.name]: "",
  [caPec.name]: "",
  [coFisso.name]: "",
  [coCellulare.name]: "",
  [caFisso.name]: "",
  [caCellulare.name]: "",
  [fax.name]: "",
  [operativaNumeroCivico.name]: "",
  [operativaProvincia.name]: "",
  [operativaCap.name]: "",
  [operativaVia.name]: "",
  [operativaComune.name]: "",
  [consentMarketing.name]: false,
  [consentProfiling.name]: false,
};

// Per definire il validationSchema si usa un array di shape che indicano gli step.
// L'ordine degli step deve corrispondere a quello in layout.
const getValidationSchema = () => {
  return [
    Yup.object().shape({
      [typeUser.name]: Yup.string()
        .oneOf(typeUser.options.map(option => option.value), <TranslatedText i18nKey="common.errors.notValid" />)
        .required(<TranslatedText i18nKey="cases.request_info.errors.required" />),
      //PRIVATE
      [name.name]: Yup.string().when(typeUser.name, {
        is: (field) => field === UserRoleEnum.PRIVATE,
        then: Yup.string()
          .required(name.requiredErrorMsg)
      }),
      [surname.name]: Yup.string().when(typeUser.name, {
        is: (field) => field === UserRoleEnum.PRIVATE,
        then: Yup.string()
          .required(surname.requiredErrorMsg)
      }),
      [surname.name]: Yup.string()
        .when(typeUser.name, {
          is: (field) => field === UserRoleEnum.PRIVATE,
          then: Yup.string().required(surname.requiredErrorMsg)
        }),
      [email.name]:Yup.string().when(typeUser.name, {
        is: (field) => field === UserRoleEnum.PRIVATE,
        then:Yup.string().matches(validEmail, {
          message: email.invalidErrorMsg,
        }).required(email.requiredErrorMsg),
      }),
      [codiceFiscale.name]: Yup.string().when(typeUser.name, {
        is: (field) => field ===  UserRoleEnum.PRIVATE,
        then: Yup.string()
          .required(codiceFiscale.requiredErrorMsg)
      }),
      [cellulare.name]: Yup.string().when(typeUser.name, {
        is: (field) => field ===  UserRoleEnum.PRIVATE,
        then: Yup.string()
          .required(cellulare.requiredErrorMsg)
      }),

      //COMPANY

      [businessName.name]: Yup.string()
        .when(typeUser.name, {
          is: (field) => field === UserRoleEnum.COMPANY,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
            .required(businessName.requiredErrorMsg)
        }),
      [businessSurname.name]: Yup.string().when(typeUser.name, {
        is: (field) => field === UserRoleEnum.COMPANY,
        then: Yup.string()
          .required(businessSurname.requiredErrorMsg)
      }),
      [fiscalCode.name]: Yup.string().when(typeUser.name, {
        is: (field) => field === UserRoleEnum.COMPANY,
        then: Yup.string()
          .required(fiscalCode.requiredErrorMsg)
      }),
      [emailAziendale.name]:Yup.string().when(typeUser.name, {
        is: (field) => field === UserRoleEnum.COMPANY,
        then:Yup.string().matches(validEmail, {
          message: email.invalidErrorMsg,
        }).required(emailAziendale.requiredErrorMsg),
      }),
      [coCellulare.name]: Yup.number().when(typeUser.name, {
        is: (field) => field === UserRoleEnum.COMPANY,
        then: Yup.number()
          .required(coCellulare.requiredErrorMsg)
      }),

      [pec.name]: Yup.string().when(typeUser.name, {
        is:(field) => field === UserRoleEnum.COMPANY,
        then: Yup.string().matches(validEmail, {
          message: pec.invalidErrorMsg,
        })
      }),
      //CONDINIUM
      [caNome.name]: Yup.string().when(typeUser.name, {
        is: (field) => field === UserRoleEnum.CONDOMINIUM_ADMIN,
        then: Yup.string()
          .required(caNome.requiredErrorMsg)
      }),
      [caCognome.name]: Yup.string().when(typeUser.name, {
        is: (field) => field === UserRoleEnum.CONDOMINIUM_ADMIN,
        then: Yup.string()
          .required(caCognome.requiredErrorMsg)
      }),
      [ragioneSociale.name]: Yup.string().when(typeUser.name, {
        is: (field) => field === UserRoleEnum.CONDOMINIUM_ADMIN,
        then: Yup.string()
          .required(ragioneSociale.requiredErrorMsg)
      }),
      [piva.name]: Yup.string().when(typeUser.name, {
        is: (field) => field === UserRoleEnum.CONDOMINIUM_ADMIN,
        then: Yup.string()
          .required(piva.requiredErrorMsg)
      }),
      [caEmail.name]:Yup.string().when(typeUser.name, {
        is: (field) => field === UserRoleEnum.CONDOMINIUM_ADMIN,
        then:Yup.string().matches(validEmail, {
          message: email.invalidErrorMsg,
        }).required(caEmail.requiredErrorMsg),
      }),
      [caCellulare.name]: Yup.number().when(typeUser.name, {
        is: (field) => field === UserRoleEnum.CONDOMINIUM_ADMIN,
        then: Yup.number()
          .required(caCellulare.requiredErrorMsg)
      }),
      [caPec.name]: Yup.string().when(typeUser.name, {
        is:(field) => field === UserRoleEnum.CONDOMINIUM_ADMIN,
        then: Yup.string().matches(validEmail, {
          message: caPec.invalidErrorMsg,
        })
      }),
      [via.name]: Yup.string().when(typeUser.name, {
        is: (field) => field === UserRoleEnum.CONDOMINIUM_ADMIN,
        then: Yup.string()
          .required(via.requiredErrorMsg)
      }),
      [numeroCivico.name]: Yup.string().when(typeUser.name, {
        is: (field) => field === UserRoleEnum.CONDOMINIUM_ADMIN,
        then: Yup.string()
          .required(numeroCivico.requiredErrorMsg)
      }),
      [cap.name]: Yup.string().when(typeUser.name, {
        is: (field) => field === UserRoleEnum.CONDOMINIUM_ADMIN,
        then: Yup.string()
          .required(cap.requiredErrorMsg)
      }),
      [comune.name]: Yup.string().when(typeUser.name, {
        is: (field) => field === UserRoleEnum.CONDOMINIUM_ADMIN,
        then: Yup.string()
          .required(comune.requiredErrorMsg)
      }),
      [provincia.name]: Yup.string().when(typeUser.name, {
        is: (field) => field === UserRoleEnum.CONDOMINIUM_ADMIN,
        then: Yup.string()
          .required(provincia.requiredErrorMsg)
      }),
      [operativaVia.name]: Yup.string().when(typeUser.name, {
        is: (field) => field === UserRoleEnum.CONDOMINIUM_ADMIN,
        then: Yup.string()
          .required(operativaVia.requiredErrorMsg)
      }),
      [operativaNumeroCivico.name]: Yup.string().when(typeUser.name, {
        is: (field) => field === UserRoleEnum.CONDOMINIUM_ADMIN,
        then: Yup.string()
          .required(operativaNumeroCivico.requiredErrorMsg)
      }),
      [operativaCap.name]: Yup.string().when(typeUser.name, {
        is: (field) => field === UserRoleEnum.CONDOMINIUM_ADMIN,
        then: Yup.string()
          .required(operativaCap.requiredErrorMsg)
      }),
      [operativaComune.name]: Yup.string().when(typeUser.name, {
        is: (field) => field === UserRoleEnum.CONDOMINIUM_ADMIN,
        then: Yup.string()
          .required(operativaComune.requiredErrorMsg)
      }),
      [operativaProvincia.name]: Yup.string().when(typeUser.name, {
        is: (field) => field === UserRoleEnum.CONDOMINIUM_ADMIN,
        then: Yup.string()
          .required(operativaProvincia.requiredErrorMsg)
      }),
    }),
  ];
};
// Il layout contiene informazioni di testo e di distribuzione sulle griglie
const layout = [
  {
    chapter: true,
    chapterName: "Form semplice 1",
    title: "",
    fields: [
      {
        fieldName: 'typeUser',
        grid: {
          xs: 12,
        },
      },
      {
        fieldName: null,
        text: (
          <h2 className='case-step-title'>
            Inserisci i tuoi dati personali
          </h2>
        ),
        grid: {
          xs: 12,
        },
      },
      {
        fieldName: name.name,
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.PRIVATE
        }],
      },
      {
        fieldName: surname.name,
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.PRIVATE
        }],
      },
      {
        fieldName: email.name,
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.PRIVATE
        }],
      },
      {
        fieldName: codiceFiscale.name,
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.PRIVATE
        }],
      },
      {
        fieldName: fisso.name,
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.PRIVATE
        }],
      },
      {
        fieldName: cellulare.name,
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.PRIVATE
        }],
      },
      {
        fieldName: businessName.name,
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.COMPANY
        }],
      },
      {
        fieldName: businessSurname.name,
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.COMPANY
        }],
      },
      {
        fieldName: fiscalCode.name,
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.COMPANY
        }],
      },
      {
        fieldName: pec.name,
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.COMPANY
        }],
      },
      {
        fieldName: emailAziendale.name,
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.COMPANY
        }],
      },
      {
        fieldName: coFisso.name,
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.COMPANY
        }],

      },
      {
        fieldName: coCellulare.name,
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.COMPANY
        }],

      },
      {
        fieldName: caNome.name,
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.CONDOMINIUM_ADMIN
        }],
      },
      {
        fieldName: caCognome.name,
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.CONDOMINIUM_ADMIN
        }],
      },
      {
        fieldName: ragioneSociale.name,
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.CONDOMINIUM_ADMIN
        }],
      },
      {
        fieldName: piva.name,
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.CONDOMINIUM_ADMIN
        }],
      },
      {
        fieldName: caPec.name,
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.CONDOMINIUM_ADMIN
        }],
      },
      {
        fieldName: caEmail.name,
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.CONDOMINIUM_ADMIN
        }],
      },
      {
        fieldName: caFisso.name,
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.CONDOMINIUM_ADMIN
        }],
      },  {
        fieldName: caCellulare.name,
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.CONDOMINIUM_ADMIN
        }],
      },  {
        fieldName: fax.name,
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.CONDOMINIUM_ADMIN
        }],
      },
      {
        fieldName: null,
        text: (
          <h2 className="case-step-title">
            Sede legale
          </h2>
        ),
        grid: {
          xs: 12,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.CONDOMINIUM_ADMIN
        }],
      },
      {
        fieldName: via.name,
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.CONDOMINIUM_ADMIN
        }],
      },
      {
        fieldName: numeroCivico.name,
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.CONDOMINIUM_ADMIN
        }],
      },
      {
        fieldName: cap.name,
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.CONDOMINIUM_ADMIN
        }],
      },
      {
        fieldName: comune.name,
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.CONDOMINIUM_ADMIN
        }],
      },
      {
        fieldName: provincia.name,
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.CONDOMINIUM_ADMIN
        }],
      },
      {
        fieldName: null,
        text: (
          <h2 className="case-step-title">
            Sede operativa
          </h2>
        ),
        grid: {
          xs: 12,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.CONDOMINIUM_ADMIN
        }],
      },
      {
        fieldName: operativaVia.name,
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.CONDOMINIUM_ADMIN
        }],
      },
      {
        fieldName: operativaNumeroCivico.name,
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.CONDOMINIUM_ADMIN
        }],
      },
      {
        fieldName: operativaCap.name,
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.CONDOMINIUM_ADMIN
        }],
      },
      {
        fieldName: operativaComune.name,
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.CONDOMINIUM_ADMIN
        }],
      },
      {
        fieldName: operativaProvincia.name,
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [{
          if: 'typeUser',
          is: UserRoleEnum.CONDOMINIUM_ADMIN
        }],
      },
      {
        fieldName: 'consentMarketing',
        grid: {
          xs: 12
        },
      },
      {
        fieldName: 'consentProfiling',
        grid: {
          xs: 12
        },
      },

    ],
  },
];

// Contiene dettagli sul case form
const formDetails = {
  title: <TranslatedText i18nKey="registration.spid.title"/>,
  description: null,
  summary: false,
  stepper: CaseStepperType.None,
  backTo: '/logout',
  backToText: <TranslatedText i18nKey="login.loginBtn"/>,
  helpText: (
    <>
        <TranslatedText i18nKey="register.help_text" />
    </>
  ),
  successText: (
    <div>
      <p>
        <TranslatedText i18nKey="cases.request_info.success_text" />
      </p>
    </div>
  ),
  autoOpenHelpModal: true
};
const translatedMapping = (payload) => {
  const Private = payload[typeUser.name] === UserRoleEnum.PRIVATE;
  const Company = payload[typeUser.name] === UserRoleEnum.COMPANY;
  const Condominium = payload[typeUser.name] === UserRoleEnum.CONDOMINIUM_ADMIN;
  return {
    mobilePhoneNumber: Private ? payload[cellulare.name] : (Condominium ? payload[caCellulare.name] : payload[coCellulare.name]),
    fiscalCode:Private ? payload[codiceFiscale.name]:(Condominium ? payload[piva.name] : payload[fiscalCode.name]),
    name:  Private? payload[name.name] : (Condominium? payload[caNome.name]: payload[businessName.name]),
    surname: Private? payload[surname.name]: (Condominium? payload[caCognome.name] : payload[businessSurname.name]),
    email: Private ? payload[email.name]: (Condominium ? payload[caEmail.name] : payload[emailAziendale.name]),
    role: payload[typeUser.name],
    ...(!Private && {pec: Company? payload[pec.name] : payload[caPec.name]}),
    landlinePhoneNumber: Private ? payload[fisso.name] : (Condominium ? payload[caFisso.name] : payload[coFisso.name]),
    businessName: payload[ragioneSociale.name],
    fax: payload[fax.name],
    customerCity: payload[comune.name],
   ...(Condominium && {
    legalAddress: {
      street: payload[via.name],
      streetNumber: payload[numeroCivico.name],
      postalCode: payload[cap.name],
      city: payload[comune.name],
      province: payload[provincia.name],
    },
    headOfficeAddress: {
      street: payload[operativaVia.name],
      streetNumber: payload[operativaNumeroCivico.name],
      postalCode: payload[operativaCap.name],
      city: payload[operativaComune.name],
      province: payload[operativaProvincia.name],
    },
  }),
    agreementProfiling: Boolean(payload[consentProfiling.name]),
    agreementMarketing: Boolean(payload[consentMarketing.name]),
  };
};


const translatedInverseMapping = (payload, values) => {
  const Private = payload[typeUser.name] = UserRoleEnum.PRIVATE;
  const Condominium = payload[typeUser.name] === UserRoleEnum.CONDOMINIUM_ADMIN;
  const errorsFields = payload.map(({field, message}) => {
    return {field, message};
  });
  const mapping = {
    "req.mobilePhoneNumber": Private ? cellulare.name : (Condominium ? caCellulare.name : coCellulare.name),
    "req.fiscalCode": Private? codiceFiscale.name : (Condominium ? piva.name : fiscalCode.name),
    "req.email": Private ? payload[email.name]: (Condominium ? caEmail.name : emailAziendale.name),
  };


  return errorsFields.reduce((acc, item) => {
    acc[mapping[item.field]] = item.message;
    return acc;
  }, {});
};


const mutation = {
  type: CaseMutationType.Custom,
  mutation: SPID_REGISTRATION
};

const main = () => {
  return {
    model,
    validationSchema: getValidationSchema(),
    initialValues,
    layout,
    formDetails,
    mutation,
    translatedMapping,
    translatedInverseMapping,
  };
};

export default main;
